import React from "react";
import PropTypes from "prop-types";
import Expander from "../../../../components/Expander";
import { EXPRESSIONS } from "./constants";

const displayExpressionsRow = (item, title) => {
  if (Array.isArray(item) && item.length > 0) {
    return (
      <tr key={title}>
        <td>{title}</td>
        <td>
          <Expander showMore="15">
            {item.map((it, i) => {
              return (
                <span key={i}>
                  {it}
                  {i < item.length - 1 ? ", " : ""}
                </span>
              );
            })}
          </Expander>
        </td>
      </tr>
    );
  }
  return null;
};

const getExpressionsData = (item) => {
  let expressionsTable = {};
  const expressionsTableBody = [];

  const header = (
    <thead>
      <tr>
        <th width="20%">Source</th>
        <th width="80%">Expressions</th>
      </tr>
    </thead>
  );

  let expressionsRow = null;

  for (const expressionsKey in EXPRESSIONS) {
    const itemKey = EXPRESSIONS[expressionsKey];
    expressionsRow = displayExpressionsRow(item[itemKey], expressionsKey);
    expressionsTableBody.push(expressionsRow);
  }

  expressionsTable = (
    <div>
      <table className="varsome-table">
        {header}
        <tbody>{expressionsTableBody}</tbody>
      </table>
    </div>
  );

  return expressionsTable;
};

const ExpressionData = ({ item }) => {
  const goResult = (
    <div style={{ marginTop: "1rem" }}>
      <div>
        <h5>Expressions Data</h5>
        <div>Tissues/organs the gene expressed in:</div>
        {getExpressionsData(item)}
      </div>
    </div>
  );

  return goResult;
};

const { shape } = PropTypes;

ExpressionData.propTypes = {
  item: shape({}),
};

ExpressionData.defaultProps = {
  item: null,
};
export default ExpressionData;
